import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

export const setApproveSaleInvoice = async (
  projectId,
  saleInvoiceId
) => {
  const apiPath = `invoice/${projectId}/sale-invoice/${saleInvoiceId}/approve`;



  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    data: {},
    body: JSON.stringify({}),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };
  console.log('request', request);
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);
  console.log('response', response)
  return response.data;
};
